import {
  HiShoppingBag,
  HiUserCircle,
  HiUserGroup,
  HiNewspaper,
  HiOutlineX,
  HiHome,
} from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { IoLogIn } from "react-icons/io5";

import { setIsCloseMenu } from "../../../redux/actions/menuActions/menuActions";
import Logo from "./../../../helpers/Logo/Logo";

const AdminMobileMenu = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const isMenuOpen = useSelector((state) => state.isOpenMenu);

  return (
    <div
      className={`${
        isMenuOpen
          ? "none animate__animated animate__fadeInRight animate__faster"
          : "animate__animated animate__fadeOutRight animate__faster hidden"
      } fixed top-0 w-7/12 z-50 lg:hidden none bg-menuBackground 
      rounded-tl-xl rounded-bl-xl h-screen

       `}
    >
      <div className="flex flex-col justify-start items-center w-full h-full space-y-5">
        {/* Logo - Close Button */}
        <div className="flex w-full justify-center items-center">
          {/* Logo */}
          <Link
            to="/Public/Home"
            onClick={() => dispatch(setIsCloseMenu())}
            className="flex flex-col items-center py-3 px-6 mt-2.5"
          >
            <Logo width={115} height={28} />
          </Link>
          {/* Close Icon */}
          <span className="absolute top-2 right-1.5">
            <span>
              <HiOutlineX
                size={30}
                onClick={() => dispatch(setIsCloseMenu())}
                className="text-white cursor-pointer z-30"
              />
            </span>
          </span>
        </div>
        {/* Items */}
        <span className="flex flex-col justify-between w-11/12 h-full">
          <span className="h-full w-full flex flex-col space-y-5 py-2">
            {/* 1 */}
            <Link
              onClick={() => dispatch(setIsCloseMenu())}
              to="/Admin/Dashboard/Profile"
              className={`${
                location.pathname === "/Admin/Dashboard/Profile"
                  ? "bg-[#255F38]"
                  : "bg-[#18230F]"
              } flex items-center px-4 py-3 w-full rounded-xl
             hover:bg-[#1F7D53] cursor-pointer text-white
              transition duration-300`}
            >
              <HiUserCircle size={30} />
              <span className="mx-2">پروفایل</span>
            </Link>
            {/* 2 */}
            <Link
              onClick={() => dispatch(setIsCloseMenu())}
              to="/Admin/Dashboard/Users"
              className={`${
                location.pathname === "/Admin/Dashboard/Users"
                  ? "bg-[#255F38]"
                  : "bg-[#18230F]"
              } flex items-center px-4 py-3 w-full rounded-xl
             hover:bg-[#1F7D53] cursor-pointer text-white
              transition duration-300`}
            >
              <HiUserGroup size={30} />
              <span className="mx-2">کاربران</span>
            </Link>
            {/* 3 */}
            <Link
              onClick={() => dispatch(setIsCloseMenu())}
              to="/Admin/Dashboard/Products"
              className={`flex items-center px-4 py-3 w-full rounded-xl
                ${
                  location.pathname === "/Admin/Dashboard/Products"
                    ? "bg-[#255F38]"
                    : "bg-[#18230F]"
                } flex items-center px-4 py-3 w-full rounded-xl
             hover:bg-[#1F7D53] cursor-pointer text-white
              transition duration-300`}
            >
              <HiShoppingBag size={30} />
              <span className="mx-2">محصولات</span>
            </Link>
            {/* 4 */}
            <Link
              onClick={() => dispatch(setIsCloseMenu())}
              to="/Admin/Dashboard/Requests"
              className={`flex items-center px-4 py-3 w-full rounded-xl
                ${
                  location.pathname === "/Admin/Dashboard/Requests"
                    ? "bg-[#255F38]"
                    : "bg-[#18230F]"
                } flex items-center px-4 py-3 w-full rounded-xl
             hover:bg-[#1F7D53] cursor-pointer text-white
              transition duration-300`}
            >
              <IoLogIn size={30} />
              <span className="mx-2">درخواست های ورود</span>
            </Link>
            {/* 5 */}
            <Link
              onClick={() => dispatch(setIsCloseMenu())}
              to="/Admin/Dashboard/News"
              className={`flex items-center px-4 py-3 w-full rounded-xl
                ${
                  location.pathname === "/Admin/Dashboard/News"
                    ? "bg-[#255F38]"
                    : "bg-[#18230F]"
                } flex items-center px-4 py-3 w-full rounded-xl
             hover:bg-[#1F7D53] cursor-pointer text-white
              transition duration-300`}
            >
              <HiNewspaper size={30} />
              <span className="mx-2">اخبار</span>
            </Link>
          </span>
          {/* Exit */}
          <span className="w-full flex py-5">
            <Link
              onClick={() => dispatch(setIsCloseMenu())}
              to="/Public/Home"
              className="flex items-center px-4 py-3 w-full rounded-xl
            bg-[#255F38] hover:bg-[#1F7D53] cursor-pointer text-white
              transition duration-300"
            >
              <HiHome size={30} />
              <span className="mx-2">خانه</span>
            </Link>
          </span>
        </span>
      </div>
    </div>
  );
};

export default AdminMobileMenu;
